import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {AuthService} from "../../services/authService";
import {InsertPatientDataPage} from "../insert-patient-data/insert-patient-data";
import {EmailService} from "../../services/email.service";

@IonicPage()
@Component({
  selector: 'page-mail-login',
  templateUrl: 'mail-login.html',
})
export class MailLoginPage {

  email: string;
  cguUrl = 'http://dr-laure-gignoux.fr/vade-mecum-mentiones-legales-cgu/';
  cguAccepted = false;

  // TODO insert email validation
  constructor(public navCtrl: NavController,
              private auth: AuthService,
              private viewCtrl : ViewController,
              private emailService: EmailService,
              public navParams: NavParams) {
  }

  async login() {
    await this.auth.login(this.email);
    await this.emailService.save(this.email);
    await this.viewCtrl.dismiss();
    this.navCtrl.push(InsertPatientDataPage);
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/mail-login/mail-login.ts